import React from "react";
import WeatherTemperature from "./WeatherTemperature";
import InfoBox from "./InfoBox";
import DataBox from "./DataBox";

export default function WeatherInfo(props) {
  return (
    <div className="card my-4">
      <div className="row g-0 text-center mx-1 lh-sm">
        <DataBox data={props.data} />
        <WeatherTemperature data={props.data} />
        <InfoBox data={props.data} />
      </div>
    </div>
  );
}
